import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";
import { Message } from "../types/Message.type";
import { useCurrentUser } from "hooks/auth";
import moment from "moment";
import SkeletonBase from "newui/components/Skeleton";
import { MessageFileList } from "./MessageFileList";
import { useMemo } from "react";

interface MessageBubbleProps {
	isLoading: boolean;
	message: Message;
}

/**
 * Displays the given message
 * @param param0
 * @returns
 */
export const MessageBubble: React.FC<MessageBubbleProps> = ({
	isLoading,
	message,
}) => {
	const { currentUser } = useCurrentUser();
	const isOwnMessage = message.sender_user_id === currentUser.id;

	const createdAt = moment(message?.created_at).format(
		"ddd DD MMM, YYYY h:mm A"
	);

	const companyName = useMemo(() => {
		const companyNameDisplay = message?.sender_company_name || "Guest User";
		if (companyNameDisplay.length > 20) {
			return (
				<Tooltip label={companyNameDisplay}>
					({companyNameDisplay.substring(0, 17)}...)
				</Tooltip>
			);
		}

		return companyNameDisplay;
	}, [message?.sender_company_name]);

	return (
		<Flex
			justify={isOwnMessage ? "flex-end" : "flex-start"}
			mb={3}
		>
			<Box
				className={`max-w-[70%] rounded-lg px-3 py-2 ${isOwnMessage ? "bg-gray-100" : "bg-blue-100"}`}
			>
				{isLoading ? (
					<SkeletonBase />
				) : (
					<>
						{" "}
						<Text
							fontSize="xs"
							color="gray.500"
						>
							{message.sender_name} - {companyName}
						</Text>
						<Box
							className="prose prose-sm"
							dangerouslySetInnerHTML={{ __html: message.body }}
						/>
						<MessageFileList files={message.files} />
						<Text
							fontSize="xs"
							color="gray.400"
							textAlign="right"
						>
							{createdAt}
						</Text>
					</>
				)}
			</Box>
		</Flex>
	);
};
